import React from 'react'
import styled from 'styled-components'

import Loading from './Loading'

const Wrapper = styled.div`
	width: 100%;
	height: auto;
	padding-bottom: ${props => `${props.height}%`};
	margin: 1em 0;
	border-radius: 3px;
	opacity: 0;
	transition: opacity 0.3s ease;

	&.visible {
		opacity: 1;
	}

	@media screen and (min-width: 1001px) {
		height: ${props => `${props.height}vh`};
		padding-bottom: 0;
	}
`;

class Img extends React.PureComponent {
	state = { visible: false }
	showImage = this.showImage.bind(this)

	componentDidMount() {
		setTimeout(this.showImage,50)
	}

	showImage() {
		this.setState({ visible: true })
	}

	render() {
		const { visible } = this.state
		const { src, percentHeight } = this.props
		const style = {
			background: `url(${src}) no-repeat center center`,
			backgroundSize: 'cover'
		}
		return <Wrapper style={style} className={visible ? "image-background visible" : "image-background"} height={percentHeight}/>
	}
}

export default class ImageFixedHeight extends React.PureComponent {
	state = { imageLoaded: false }
	fetchImage = this.fetchImage.bind(this)
	imageLoaded = this.imageLoaded.bind(this)
	_mounted = false

	componentWillMount() {
		this.fetchImage()
	}
	componentDidMount() {
		this._mounted = true
	}
	componentWillUnmount() {
		this._mounted = false
	}
	fetchImage() {
		if (typeof document !== 'undefined') {
			let img = document.createElement('img')
			img.src = this.props.src
			img.addEventListener('load', this.imageLoaded)
		}
	}
	imageLoaded() {
		this._mounted && this.setState({ imageLoaded: true })
	}
	render() {
		const { src, heightPercent } = this.props
		const { imageLoaded } = this.state
		return(
			imageLoaded
				? <Img src={src} percentHeight={heightPercent}/>
				: <Loading color="#ff486a" percentHeight={heightPercent}/>
		)
	}
}


// WEBPACK FOOTER //
// /opt/build/repo/src/components/common/ImageFixedHeight.js